export default __webpack_public_path__ + "static/trading-analytix-white-footer-730311397f77e7f0bacc0d8138f83bff.png";